import { CaretRight } from '@phosphor-icons/react';

type SettingsRowProps = {
  row: any;
  onSelect: (view: string) => void;
};

export default function SettingsRow({ row, onSelect }: SettingsRowProps) {
  const Icon = row.icon;

  return (
    <button onClick={() => onSelect(row.view)}>
      <span className={`setting-icon ${row.admin ? 'admin' : ''}`}><Icon /></span>
      <span><b>{row.label}</b><small>{row.description}</small></span>
      <CaretRight />
    </button>
  );
}
